<template>
  <div>

    <!-- header -->

    <div  class="container-fluid bg-light sticky-top py-3 box-shadow-normal">
      <div class="container">
        <div class="row">
          <div class="col-4 col-md-2"><img src="brands/Logo-mgl.png" height="60px"></div>
          <div class="col-1 col-md-1"></div>
          <div class="col-7 col-md-9 align-items-center col-6 d-flex font-01 justify-content-end nav-custom">
            <div><a href="#carouselExampleIndicators"     v-smooth-scroll>Início</a></div>
            <div><a href="#MGL"     v-smooth-scroll>SOBRE</a></div>
            <div><a href="#MGL"     v-smooth-scroll>OFICINA</a></div>
            <div><a href="#Contactos" v-smooth-scroll>CONTACTOS</a></div>
            <div>
              <a href="https://www.facebook.com/mendesgomeslda/"><i class="fa-brands fa-facebook px-3 fa-xl"></i></a>
              <a href="https://www.instagram.com/mgl_mendesgomes/" target="_blank"><i class="fa-brands fa-instagram fa-xl"></i></a>
            </div>
          </div>
        </div>
      </div>     
  </div>

  <heroImage></heroImage>

  <!-- Brands ROW -->

  <div id="brands" class="container-fluid g-0 brand-wrapper">
    <div     
    
      class="d-flex flex-wrap align-items-center justify-content-center">

      <div class="brand-hold" @click="getwebsiteLauncher('abarth')"            href="#brands" v-smooth-scroll><img src="brands/marca_Abarth.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('alfaRomeu')"         href="#brands" v-smooth-scroll><img src="brands/marca_alfaRomeu.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('Fiat')"              href="#brands" v-smooth-scroll><img src="brands/marca_fiat.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('Fiat Professional')" href="#brands" v-smooth-scroll><img src="brands/marca_fiatProfissional.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('Jeep')"              href="#brands" v-smooth-scroll><img src="brands/marca_jeep.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('Toyota')"            href="#brands" v-smooth-scroll><img src="brands/marca_toyota.png" alt=""></div>
      <div class="brand-hold" @click="getwebsiteLauncher('Volvo')"             href="#brands" v-smooth-scroll><img src="brands/marca_volvo.png" alt=""></div>
      <!-- <div class="brand-hold" @click="getwebsiteLauncher('MglUsados')"><img src="brands/mgl-03-p-500.png" alt=""></div> -->
    </div>
  </div>

  <!-- Website Launcher-->

  <Transition name="fade">
    <div class="brand-website" v-if="websiteLaunch" >
      <div class="container col-xxl-8 px-4 py-5">
        <div class="row align-items-center g-5 py-5">
        
   

          <div class="col-lg-5">
            <TransitionGroup name="fade">
            <template v-for="(items, index) in getwebsiteLauncher(websiteLaunchParam)">
                <div :key="items">
                  <div class="display-5 fw-bold lh-1 mb-3 d-flex align-items-center">
                    <div><img :src="'brands/' + items.logo" height="60px" class="me-2" /> </div>
                    <div class="font-02 text-secondary" > | {{items.carBrand}}</div>
                  </div>
                  <p class="lead">Explore a nossa selecção de veículos  <b>{{items.carBrand}}</b>  através dos seguintes acessos:</p>
                  <div class="d-flex gap-2 d-md-flex justify-content-md-start" >
                      <a :href="items.website"    target="_blank"><img src="interface/website_icon.png"  class="img-fluid" alt=""></a>
                      <a :href="items.semiNovos"  target="_blank"><img src="interface/website_SemiNovos.png"  class="img-fluid" alt=""></a>
                      <a :href="items.configurar" target="_blank"><img src="interface/website_Configurar.png"  class="img-fluid" alt=""></a>
                  </div>
                </div>
            </template>
          </TransitionGroup>
          </div>

          <template v-for="(items, index) in getwebsiteLauncher(websiteLaunchParam)"  >
          <div class="col-12 col-md-4 col-lg-6 d-flex align-items-center">
            <img 
            :src="'interface/' + items.websitePreview" 
            class="d-block mx-lg-auto img-fluid shadow-lg rounded-2" alt="Bootstrap Themes" width="800" height="500" loading="lazy"
            >
          </div>
        </template>

        </div>
      </div>
    </div>
  </Transition>

  <!-- Contents -->
  <div id="MGL" class="container-fluid" >
    <div class="" >
      <div class="row">

        <div class="col-12 col-md-6 d-flex flex-column align-items-center position-relative" style="background-image:url(photo/sobre-nos-side-3.jpg); background-size: cover;">     
          
          <div class="background-shade"></div>         
          <div class="d-flex flex-column align-items-center" style="z-index: 2">

            <div class="mt-5 font-03 px-5 section-title text-center color-pale-green">
              Sobre Nós
            </div>
            
            <div><img src="/interface/icon-sobrenos.svg" alt="" width="100px" class="mt-5"></div>

            <p class="my-5 font-03 px-5 text-small text-muted ">
              Fundada em 15 de Fevereiro de 1949. Desde o início da sua actividade a Empresa dedicou-se
              à comercialização dos Motores VOLVO PENTA. Em Junho de 1967 é assinado o primeiro contrato de concessão com a
              “ Auto Sueco, Lda. “, Importador para Portugal dos Automóveis, Camiões, Autocarros e Peças VOLVO. Desde então
              a comercialização do Produto VOLVO passou a ser a actividade principal da Empresa. Em 1968 verifica-se um
              grande incremento do negócio VOLVO e a introdução e desenvolvimento do Pós Venda da TOYOTA, marca que era
              representada pela União Comercial (Funchal) Lda. Em 1988 o Capital Social da “Mendes Gomes &amp; C.ª Lda.“
              passou a ser detido 100% por Emílio de Castro Sottomayor Tavares e Filhos - ( 90% por “ Sottomayor Tavares,
              S.A “ e 10% por Emílio de Castro Sottomayor Tavares ).
              <br><br> Desde 1992, ano do falecimento do Sócio Emílio de Castro Sottomayor Tavares, o Capital e Gestão da
              Empresa está na posse dos seus Herdeiros. Em Dezembro de 2007 foram assinados os contratos de concessionário e
              de oficina de reparação autorizada com a Volvo Car Portugal S.A.. Em Fevereiro de 2015, foram assinados os
              contratos de concessão de venda de veículos, serviço e peças com a FIAT e FIAT PROFESSIONAL e o contrato de de
              concessão de serviço e peças com a ALFA ROMEO. Em Setembro 2017 foram igualmente assinados os contratos de
              concessão de venda de Veículos ALFA ROMEO E JEEP.
              <br><br>Há 70 anos que a MENDES GOMES &amp; Cª Lda com os seus pontos de venda e assistência proporciona aos
              seus clientes um serviço especializado através de uma equipa de profissionais com uma vasta experiência.
              Assente no nosso legado e pensando o futuro com inovação o nosso compromisso é continuar a proporcionar valor
              ao cliente.</p>
          </div>
        

        </div>


        <div class="col-12 col-md-6 d-flex flex-column align-items-center position-relative"  style="background-image:url(photo/oficina.jpg); background-size: cover;"> 

          <div class="background-shade-dark"></div>
         
          <div class="d-flex flex-column align-items-center" style="z-index: 2">

            <div class="mt-5 font-03 px-5 section-title text-center color-pale-green">Oficinas</div>
            <img src="/interface/icon-oficina.svg" alt="" width="75px" class="mt-5">
            <p class="text-light my-5 font-03 px-5 text-normal">Somos o serviço oficial da marca VOLVO e oferecemos os melhores produtos e serviços para a manutenção da sua viatura.
               <br><br>Todas as operações são efetuadas com Peças e Acessórios originais que seguem os mais altos padrões de qualidade e segurança.<br><br> As nossas oficinas estão dotadas de equipamentos atualizados. A nossa equipa de profissionais especializada está sempre ao seu serviço.</p>
          </div>


        </div>


        
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div id="Contactos" class="footer-wrapper pb-3">
    <div class="container">
      <div class="row">

      <div class="col-12 col-md-1 opacity-50 my-3 p-0 footer-logo-control">

            <div><img src="/brands/Logo-mgl.png" class="img-fluid mb-3" width="125px" alt=""></div>

            <div class="">
              <a class="color-black" href="https://www.facebook.com/mendesgomeslda/" target="_blank"><i class="fa-brands fa-facebook fa-xl me-2 "></i></a>
              <a href="https://www.instagram.com/mgl_mendesgomes/" target="_blank"><i class="fa-brands fa-instagram fa-xl color-black"></i></a>
            </div>
      </div>

      <div class="col-12 col-md-4 font-03 text-bold mx-lg-5 mx-0">
        

        <template v-for="(items, index) in getMoradas(moradasParam)">     

              <div class="d-flex align-items-center my-3"> 
                <div><img src="/interface/icon-Location.svg" class="me-3" alt=""></div> 
                <div>{{items.morada}}</div>
              </div>

              <div class="d-flex align-items-center my-3"> 
                <div><img src="/interface/icon-Envelope.svg" class="me-3" alt=""></div> 
                <div>{{items.email}}</div>
              </div>
              
              <div class="d-flex align-items-center my-3"> 
                <div><img src="/interface/icon-Horario.svg" class="me-3" alt=""></div> 
                <div>{{items.horario}}</div>
              </div>

              <div class="d-flex align-items-center my-3"> 
                <div><img src="/interface/icon-Phone.svg" class="me-3"  alt=""></div> 
                <div>{{items.telefone}}</div>
              </div>

              <div class="d-flex align-items-center my-3"> 
                <div><img src="/interface/icon-Path.svg" class="me-3" alt=""></div> 
                <div><a :href="items.comoChegar" target="_blank" ><img src="/interface/icon-comoChegar.svg" class="me-3"  alt=""></img></a></div>
              </div>

        </template>

      </div>

      <div class="col">       
          <div class="row">

             <div class="button-location-group d-flex flex-wrap mt-3 p-0 m-0">
    
                <div class="button-location"
                :class="{ active: moradasParam == 'Oficinas' }"
                @click="getMoradas('Oficinas')">
                  <img src="interface/icon-Location.svg"> <div>Oficinas</div>
                </div>
    
                <div class="button-location"
                :class="{ active: moradasParam == 'Volvo' }"
                @click="getMoradas('Volvo')">
                  <img src="interface/icon-Location.svg"> <div>Volvo</div>
                </div>
    
                <div class="button-location"
                :class="{ active: moradasParam == 'Toyota' }"
                @click="getMoradas('Toyota')">
                  <img src="interface/icon-Location.svg"> <div>Toyota</div>
                </div>
    
                <div class="button-location"
                :class="{ active: moradasParam == 'Fiat/Jeep/Alfa Romeo' }"
                @click="getMoradas('Fiat/Jeep/Alfa Romeo')">
                  <img src="interface/icon-Location.svg"> <div>Fiat/Jeep/Alfa Romeo</div>
                </div>

              </div>

          </div>

          <div class="row g-0">
            <div class="border-top my-3"></div>
            <div class="d-flex justify-content-between align-items-center">
              <div><b>MENDES GOMES & C.LDA</b></div>
              <a href="https://www.livroreclamacoes.pt/inicio" target="_blank">
                <div><img src="interface/icon-livroReclamacoes.png" alt="" height="40px"></div>
              </a>
            </div>
          </div>
          <div class="row">
            <div><a href="files/FichaProjecto.pdf"><img src="interface/footer-portugal2020.png" class="mt-5 img-fluid" alt=""></a></div>
          </div>   
      </div>        
      </div>
    </div>
  </div>

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

  </div>
  
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import heroImage from '@/components/heroImage.vue'
import '@/assets/main.css'
import '@/assets/css_tools.css'


export default {
  name: 'HomeView',
  components: {
    //HelloWorld
    heroImage
  },

  mounted() { },

  data() {
    return {
      websiteLaunch: false,
      websiteLaunchParam: "abarth",
      moradasParam: "Oficinas",


      websiteLauncher: 
        [
              {
                id: 1, carBrand: 'abarth',
                website: "https://www.mgl-fcadealer.pt/concessionario/abarth",
                semiNovos: "https://www.mgl-fcadealer.pt/concessionario/abarth/procura-automoveis/automoveis-em-stock?brand-code=066&condition=stock&order-by=relevance",
                configurar: "https://www.abarth.pt/configurador/",
                logo: "marca_Abarth.png",
                websitePreview: 'website-abarth.jpg'
              },
              {
                id: 2, carBrand: 'alfaRomeu',
                website: "https://www.mgl-fcadealer.pt/concessionario/alfa-romeo",
                semiNovos: "https://www.mgl-fcadealer.pt/concessionario/alfa-romeo/procura-automoveis/automoveis-em-stock?brand-code=083&condition=stock&order-by=relevance",
                configurar: "https://www.alfaromeo.pt/configurador/",
                logo: "marca_alfaRomeu.png",
                websitePreview: 'website-alfaRomeu.jpg'
              },
              {
                id: 3, carBrand: 'Fiat',
                website: "https://www.mgl-fcadealer.pt/concessionario/fiat",
                semiNovos: "https://www.mgl-fcadealer.pt/concessionario/fiat/procura-automoveis/automoveis-em-stock?brand-code=000&condition=stock&order-by=relevance",
                configurar: "https://www.fiat.pt/configurador/",
                logo: "marca_fiat.png",
                websitePreview: 'website-fiat.jpg'
              },
              {
                id: 4, carBrand: 'Fiat Professional',
                website: "https://www.mgl-fcadealer.pt/concessionario/fiat-professional",
                semiNovos: "https://www.mgl-fcadealer.pt/concessionario/fiat-professional/procura-automoveis/automoveis-em-stock?brand-code=077&condition=stock&order-by=relevance",
                configurar: "https://www.fiatprofessional.com/pt/configurador",
                logo: "marca_fiatProfissional.png",
                websitePreview: 'website-fiatPro.jpg'
              },
              {
                id: 5, carBrand: 'Jeep',
                website: "https://www.mgl-fcadealer.pt/concessionario/jeep",
                semiNovos: "https://www.mgl-fcadealer.pt/concessionario/jeep/procura-automoveis/automoveis-em-stock?brand-code=057&condition=stock&order-by=relevance",
                configurar: "https://www.jeep.pt/configurador/",
                logo: "marca_jeep.png",
                websitePreview: 'website-Jeep.jpg'
              },
              {
                id: 5, carBrand: 'Toyota',
                website: "https://www.toyota.pt/",
                semiNovos: "https://usados.toyota.pt/viaturas/pesquisa/Mendes-Gomes/",
                configurar: "https://www.toyota.pt/carros",
                logo: "marca_toyota.png",
                websitePreview: 'website-Toyota.jpg'
              },
              {
                id: 5, carBrand: 'Volvo',
                website: "https://www.volvocars.com/PT",
                semiNovos: "",
                configurar: "https://www.volvocars.com/pt/build",
                logo: "marca_volvo.png",
                websitePreview: 'website-Volvo.jpg'
              },
              {
                id: 5, carBrand: 'MglUsados',
                website: "volvo.pt",
                semiNovos: "seminovos",
                configurar: "configurar",
                logo: "mgl-03-p-500.png"
              },       
            ],   


      moradas:
        [     
          {
            local: 'Oficinas', morada: 'Parque Industrial da Cancela Pavilhão 5.1 a 5.5', email: 'comercial@mgl.pt',
            horario: 'Segunda a Sexta: 8h30-12h30 / 13h30- 17h30', telefone: '291 934 400',
            comoChegar: 'https://www.google.com/maps/dir/38.6027948,-9.090288/32.650295,-16.85851/@35.5431141,-17.4658968,6z/data=!3m1!4b1!4m4!4m3!1m1!4e1!1m0'
          },
          {
            local: 'Volvo', morada: 'Parque Industrial da Cancela Pavilhão 5.5', email: 'comercial@mgl.pt',
            horario: 'Segunda a Sexta: 08:30 / 18:30.', telefone: '291 934 400',
            comoChegar: 'https://www.google.com/maps?ll=32.650533,-16.858914&z=19&t=m&hl=pt-PT&gl=PT&mapclient=embed&cid=11280446949836588914'
          },
          {
            local: 'Toyota', morada: 'Caminho do Poço Barral nº40', email: 'toyota@mgl.pt',
            horario: 'Segunda a Sexta 09:00-19:00. Sábado: 10:00-14:00 ', telefone: '291 200 080',
            comoChegar: 'https://www.google.com/maps?ll=32.656771,-16.944565&z=20&t=m&hl=pt-PT&gl=PT&mapclient=embed&cid=11405967208423523152'
          },
          {
            local: 'Fiat/Jeep/Alfa Romeo', morada: 'Parque Industrial da Cancela Pavilhão 3.1', email: 'comercial@mgl.pt',
            horario: 'Segunda a Sexta 09:00-19:00. Sábado: 09:00-14:00 ', telefone: '291 934 400',
            comoChegar: 'https://www.google.com/maps?ll=32.65199,-16.860637&z=17&t=m&hl=pt&gl=PT&mapclient=embed&cid=10915889666945361465'
          }
        ]
    }
  },
  methods: { 

    getwebsiteLauncher(param1) {

      if ( this.websiteLaunch === false)
      { 
        //alert(this.websiteLaunch)
        this.websiteLaunch = true
      }

      var paramId = param1 //id to check      

      var thisArray = this.websiteLauncher
      var filteredArray = thisArray.filter(item => item.carBrand == paramId)

      this.websiteLaunchParam = param1
      return filteredArray
    },
      
    getMoradas(param1)
    {
      var paramId = param1 //id to check      

      var thisArray = this.moradas
      var filteredArray = thisArray.filter(item => item.local == paramId)      

      this.moradasParam = param1      
      return filteredArray
      
     }
    
      } 
}
</script>
